export const MESSAGE_CHANNEL_NAME = '__COMLINK_MESSAGE_CHANNEL__';

export const MESSAGE_PORT_MARKER = '__COMLINK_MESSAGE_PORT_MARKER__';

export const MESSAGE_EVENT_NAME = 'message';

export const MESSAGE_EVENT_ERROR = 'Only message event is supported';

export const PROXY_MESSAGE_CHANNEL_MARKER = '__PROXY_MESSAGE_CHANNEL_MARKER__';